import React, {Fragment, Suspense} from 'react';
import MasterLayout from "../../components/MasterLayout/MasterLayout";
import LazyLoader from "../../components/MasterLayout/LazyLoader";
import WarehouseList from '../../components/Warehouse/WarehouseList';
const WarehouseListPage = () => {
    return (
        <Fragment>
            <MasterLayout>
                <Suspense fallback={<LazyLoader/>}>
                    <WarehouseList/>
                </Suspense>
            </MasterLayout>
        </Fragment>
    );
};
export default WarehouseListPage;